module.exports = __webpack_public_path__ + "img/app_default.778d7340.png";